<section class="content">
    <div class="container-fluid">
        <div class="row mt-5">
            <div class="row mb-3 d-flex justify-content-start">
                <div class="col-lg-4 col-md-12 mt-2">
                    <h5 class="font-italic mt-3 ">Shop Owner Details</h5>
                </div>
                <div class="col-lg-8 col-md-12 mt-3">
                    <div>
                        <div class="d-grid gap-2 d-flex justify-content-end">
                             <span class="badge p-3"
                                   [ngClass]="{'badge-gradient-info': userAndShopDetailsById?.approvalStatus   === 'RE APPROVED',
                                  'badge-gradient-brown': userAndShopDetailsById?.approvalStatus   === 'SUSPENDED',
                                  'badge-gradient-green': userAndShopDetailsById?.approvalStatus   === 'APPROVED',
                                  'badge-gradient-red': userAndShopDetailsById?.approvalStatus   === 'NOT APPROVED' }">
                                {{ getApprovalStatusText(userAndShopDetailsById?.approvalStatus) }}</span>
                            <button class="btn btn-success me-md-2" type="button"
                                    (click)="approveStatus('APPROVED', userId)"
                                    *ngIf="userAndShopDetailsById?.approvalStatus == 'NOT APPROVED'">Approve
                            </button>
                            <button class="btn btn-warning me-md-2" type="button"
                                    *ngIf="userAndShopDetailsById?.approvalStatus == 'APPROVED' || userAndShopDetailsById?.approvalStatus == 'RE APPROVED'"
                                    (click)="approveStatus('SUSPENDED', userId)">Suspend
                            </button>
                            <button class="btn btn-info me-md-2" type="button"
                                    *ngIf="userAndShopDetailsById?.approvalStatus == 'SUSPENDED'"
                                    (click)="approveStatus('RE APPROVED', userId)">Re Approve
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row mt-3">
                <div class="col-12 col-lg-4 col-md-6 mt-2">
                    <div class="bg-white-detail p-3 h-100">
                        <p class="mb-0">First Name</p>
                        <span class="mt-0 fw-bold">{{userAndShopDetailsById?.firstName || '-'}}</span>
                    </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 mt-2">
                    <div class="bg-white-detail p-3 h-100">
                        <p class="mb-0">Last Name</p>
                        <span class="mt-0 fw-bold">{{userAndShopDetailsById?.lastName || '-'}}</span>
                    </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 mt-2">
                    <div class="bg-white-detail p-3 h-100">
                        <p class="mb-0">Phone Number</p>
                        <span class="mt-0 fw-bold">{{userAndShopDetailsById?.phoneNumber || '-'}}</span>
                    </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 mt-2">
                    <div class="bg-white-detail p-3 h-100">
                        <p class="mb-0">Email</p>
                        <span class="mt-0 fw-bold">{{userAndShopDetailsById?.emailId || '-'}}</span>
                    </div>
                </div>

                <div class="col-12 col-lg-4 col-md-6 mt-2">
                    <div class="bg-white-detail p-3 h-100">
                        <p class="mb-0">First Name</p>
                        <span class="mt-0 fw-bold">{{userAndShopDetailsById?.firstName || '-'}}</span>
                    </div>
                </div>


                <div class="col-12 col-lg-4 col-md-6 mt-2">
                    <div class="bg-white-detail p-3 h-100">
                        <p class="mb-0">Shop Owner Status</p>
                        <span class="mt-0 fw-bold">{{ getApprovalStatusText(userAndShopDetailsById?.approvalStatus) || '-'}}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-5 mb-3">
            <div class="col-12 mb-3">
                <h5 class="font-italic">Shop Owner Shops Details</h5>
            </div>
        </div>

        <div class="row mt-3 mb-3">
            <div class="col-12 col-lg-12 col-md-12">
                <div class="card direct-chat direct-chat-primary bg-white"
                     *ngFor="let shops of shopDetails; let i = index;">
                    <div class="card-header ui-sortable-handle bg-white-detail"
                         matTooltip="click to show {{ shops?.shopName || '-' }} details & products"
                         style="cursor: move;"
                         (click)="toggleCard(i, shops.traderId)">
                        <span class="card-title fw-bold mt-2">{{ shops?.shopName || '-' }}</span>
                        <div class="card-tools">
                            <button type="button" class="btn btn-tool border-0">
                                <i class="fas" [ngClass]="isCardCollapsed[i] ? 'fa-minus' : 'fa-plus'"></i>
                            </button>
                        </div>
                    </div>

                    <div class="card-body" [style.display]="isCardCollapsed[i] ? 'block' : 'none'">
                        <div class="direct-chat-messages">
                            <div class="row">
                                <div class="col-lg-12 col-12 col-12">
                                    <div class="gap-2 d-flex justify-content-end">
                                        <span class="badge p-3" [ngClass]="{
                                'badge-gradient-green': shops?.status === 'Active',
                                'badge-gradient-red': shops?.status !== 'Active'}">{{ shops?.status }}</span>
                                        <button class="btn btn-success me-md-2" type="button"
                                                (click)="shopApproveStatus('Active', shops.shopId, userAndShopDetailsById?.approvalStatus)"
                                                *ngIf="shops?.status == 'InActive'">Approve
                                        </button>
                                        <button class="btn btn-danger me-md-2" type="button"
                                                *ngIf="shops?.status == 'Active' "
                                                (click)="shopApproveStatus('InActive', shops.shopId, userAndShopDetailsById?.approvalStatus)">
                                            In Active
                                        </button>
                                        <!--<button class="btn btn-info me-md-2" type="button"
                                                *ngIf="shops?.status == 'SUSPENDED'"
                                                (click)="shopApproveStatus('RE APPROVED', shops.shopId, userAndShopDetailsById?.approvalStatus)">
                                            Re Approve
                                        </button>-->
                                    </div>
                                </div>
                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Shop Name</p>
                                        <span class="mt-0 fw-bold text-capitalize">{{ shops?.shopName || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Shop Type</p>
                                        <span class="mt-0 fw-bold text-capitalize">{{ shops?.shopType || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">GST No</p>
                                        <span class="mt-0 fw-bold text-capitalize">{{ shops?.gstNo || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Shop Phone Number</p>
                                        <span class="mt-0 fw-bold text-capitalize">{{ shops?.contactNo || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Email Id</p>
                                        <span class="mt-0 fw-bold">{{ shops?.supplierEmail || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Merchant UPI ID</p>
                                        <span class="mt-0 fw-bold">{{ shops?.upiIdOne || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Working Hours</p>
                                        <span class="mt-0 fw-bold">{{ shops?.workingHrs || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Shop Created Date</p>
                                        <span class="mt-0 fw-bold text-capitalize">{{ shops?.createdAt ? (shops.createdAt | date: 'dd-MM-yyyy') : 'N/A' }}</span>

                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Min Order Value</p>
                                        <span class="mt-0 fw-bold text-capitalize">{{ shops?.minimumOrderValue || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Delivery Lead Day</p>
                                        <span class="mt-0 fw-bold">{{ getDeliveryLeadDate(shops?.deliveryLeadDate) }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Delivery Time</p>
                                        <span class="mt-0 fw-bold">{{ shops?.deliveryLeadTime || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Packing Lead Time</p>
                                        <span class="mt-0 fw-bold">
                                            {{ shops?.packingLeadTime !== null && shops?.packingLeadTime !== undefined ? shops.packingLeadTime + ' Hrs' : '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Shop Latitude</p>
                                        <span class="mt-0 fw-bold">
                                            {{ shops?.latitude || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Shop Longitude</p>
                                        <span class="mt-0 fw-bold">
                                             {{ shops?.longitude || '-' }}</span>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-12 col-md-6 mt-2">
                                    <div class="detail-view-card p-3">
                                        <p class="mb-0 text-gray">Shop Address</p>
                                        <span class="mt-0 fw-bold">{{ getFormattedAddress(shops) || '-'}}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="row mt-3 mb-3">
                                <div class="table-responsive table-style">
                                    <table class="table table-head-fixed table-striped">
                                        <thead class="text-center">
                                        <tr>
                                            <th>S.No</th>
                                            <th>Product Name</th>
                                            <th>Category</th>
                                            <th>Sub Category</th>
                                            <th>MRP</th>
                                            <th>SRP</th>
                                            <th>Status</th>
                                        </tr>
                                        </thead>
                                        <tbody class="text-center"
                                               *ngIf="this.productDetails.length > 0; else noDataFound">
                                        <tr *ngFor="let product of this.productDetails; let i = index;">
                                            <td>{{ i + 1 }}</td>
                                            <td class="col-2">{{ product?.productName || '-' }}</td>
                                            <td>{{ product?.mainProductCategory?.catName || '-' }}</td>
                                            <td>{{ product?.subProductCategory?.subCatName || '-' }}</td>
                                            <td>{{ product?.shopProductMRP ? (product.shopProductMRP | currency: 'INR':'symbol':'1.0-0') : '-' }}</td>
                                            <td>{{ product?.shopProductSRP ? (product.shopProductSRP | currency: 'INR':'symbol':'1.0-0') : '-' }}</td>
                                            <td>
                                <span class="badge" [ngClass]="{
                                'badge-gradient-green': product.status === 'Active',
                                'badge-gradient-red': product.status !== 'Active'}">{{ product.status }}</span>
                                            </td>
                                        </tbody>
                                        <ng-template #noDataFound>
                                            <tr>
                                                <td colspan="12" class="text-center text-danger">Data Not Found</td>
                                            </tr>
                                        </ng-template>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>